import React from 'react';
import { Typography } from '@saucelabs/ds-typography';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';

type TableCellNameProps = {
  file: appStorageRecords.AppStorageFile,
};

const TableCellName: React.FC<TableCellNameProps> = ({ file }) => (
  <div className="min-w-34.75 break-all">
    <Typography
      className="text-high-emphasis font-semibold"
    >
      {file.name}
    </Typography>
    <Typography
      className="text-disabled-emphasis"
    >
      {file.getPrettyFileSize()}
    </Typography>
  </div>
);

export default TableCellName;
